export default [{
  path: '/activity',
  name: 'activity',
  component: () => import('@/app/activity-template/ActivityTemplateView'),
  children: [
    { path: '/activity/:id', component: () => import('@/app/activity-template/ActivityTemplateView'), name: 'viewcard' }
  ],
  meta: {
    resource: 'templates',
    actions: ['read']
  }
}]
